import { render, staticRenderFns } from "./editStrategyDialog.vue?vue&type=template&id=37645c87"
import script from "./editStrategyDialog.vue?vue&type=script&lang=js"
export * from "./editStrategyDialog.vue?vue&type=script&lang=js"
import style0 from "./editStrategyDialog.vue?vue&type=style&index=0&id=37645c87&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37645c87')) {
      api.createRecord('37645c87', component.options)
    } else {
      api.reload('37645c87', component.options)
    }
    module.hot.accept("./editStrategyDialog.vue?vue&type=template&id=37645c87", function () {
      api.rerender('37645c87', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/receiverApp/channelstrategyConfig/components/editStrategyDialog.vue"
export default component.exports